<template>
    <div>
        <v-server-table :name="tableName" :ref="tableName" url="/jobsite/list" :columns="columns" :options="options">

            <div slot="afterFilterWrapper" class="ml-md-2 ml-0 mt-md-0 mt-2 mb-md-0 mb-3 float-md-left">
                <div class="clearfix d-md-none d-block"></div>

                <div v-if="allowFilterSaving" class="float-left mr-1">
                    <user-filters ref="jobsiteSavedFilters" assetType="Jobsite" :filterKey="filterKey" @saving="setUserFilterData" @show="setUserFilterData"></user-filters>
                </div>

                <div class="float-left">
                    <table-filters-2 ref="jobsiteTableFilters"
                        filterUrl="/jobsite/filters"
                        v-bind:filters="filters"
                        :emptyFilters="filterDefs"
                        :filterKey="filterKey"
                        @filtersChanged="refreshTableData"
                        @filtersCleared="filtersCleared"
                        v-show="!dashboardFilters">
                        <template slot-scope="slotProps">
                            <div class="d-inline-block">
                                <multi-select v-model="slotProps.filters['jobsite.DivisionId']" :btnLabel="(values) => ('Divisions ('+values.length+')')" :selectOptions="slotProps.filterData.divisions" :options="{multi: true}"></multi-select>
                            </div>
                            <div class="d-inline-block">
                                <b-form-select v-model="slotProps.filters['jobsite.IsActive']" size="sm" :options="[{value: null, text: '-- Show Active/Inactive --'}, {value: 0, text: 'Inactive'}, {value: 1, text: 'Active'}]"></b-form-select>
                            </div>
                            <div class="d-inline-block">
                                <date-range-selector buttonTitle="Jobsite Created Date" v-model="slotProps.filters['jobsite.created_at']" />
                            </div>
                            <div class="d-inline-block" style="width: 250px;" v-if="$root.hasPermission(['employees.view'])">
                                <employee-select :forFilters="true" :selectedValues="slotProps.filters['jobsite.project_manager_id']" v-on:vselected="((data) => { slotProps.filters['jobsite.project_manager_id'] = data || {};  })"></employee-select>
                            </div>
                        </template>
                    </table-filters-2>
                </div>

                <button type="button" class="btn btn-outline-success ml-2" v-on:click="exportTable()" :disabled="exportingTable">
                    <template v-if="!exportingTable"><i class="fa fa-file-excel-o"></i> Export</template>
                    <template v-else><i class="fa fa-circle-o-notch fa-spin"></i> Exporting</template>
                </button>

                <div class="clearfix d-sm-none d-block"></div>
            </div>

            <router-link slot="JobsiteName" slot-scope="props" :to="`/jobsites/view/${props.row.JobsiteId}`" title="View Jobiste">
                {{ props.row.JobsiteName }}
            </router-link>

            <template slot="JobsiteNumber" slot-scope="props">
                {{ props.row.JobsiteNumber }}
            </template>

            <template slot="DivisionName" slot-scope="props">
                {{ props.row.division_code }} - {{ props.row.DivisionName }}
            </template>

            <template slot="Address" slot-scope="props">
                {{ props.row.Address }} <template v-if="props.row.Address2">{{ props.row.Address2 }}</template>
            </template>

            <template slot="City" slot-scope="props">
                {{ props.row.City }}
            </template>

            <template slot="State" slot-scope="props">
                {{ props.row.State }}
            </template>

            <template slot="Zip" slot-scope="props">
                {{ props.row.Zip }}
            </template>

            <template slot="IsActive" slot-scope="props">
                <label class="badge badge-success" v-if="props.row.IsActive == 1">Active</label>
                <label class="badge badge-warning" v-else>Inactive</label>
            </template>

            <template slot="pm_last_name" slot-scope="props">
                <router-link :to="`/employees/view/${props.row.JobsiteId}`" title="View Project Manager" v-if="props.row.project_manager_id">
                    {{ props.row.pm_first_name }} {{ props.row.pm_last_name }}<span v-if="props.row.pm_employee_number"> - {{ props.row.pm_employee_number }}</span>
                </router-link>
            </template>

            <template slot="percent_risk" slot-scope="props">
                <template v-if="props.row.percent_risk !== null">
                    <b-progress :title="riskLabel(parseFloat(props.row.percent_risk))">
                        <b-progress-bar :value="parseFloat(props.row.percent_risk)" :variant="riskColor(parseFloat(props.row.percent_risk))" />
                    </b-progress>
                </template>
            </template>

            <template slot="created_at" slot-scope="props">
                {{ props.row.created_at | moment('timezone', userTimezone, "MM/DD/YYYY hh:mm a") }}
            </template>

        </v-server-table>
    </div>
</template>

<script>
    import filterExtractor from '@/helpers/TableFilterExtractor';
    import customVTColDropdown from '@/components/vue-tables-2/CustomColumnDropdown';

    export default {
        props: {
            assetType: {
                type: String,
                default: null,
            },

            assetId: {
                //type: Number,
                default: null,
            },

            allowFilterSaving: {
                //type: Boolean,
                default: false,
            },

            filterId: {
                type: Number,
                default: null,
            },

            dashboardFilters: {
                type: Object,
                default(){
                    return null;
                },
            },

            tableConfig: {
                type: Object,
                default(){
                    return null;
                },
            },
        },

        data() {
            return {
                userTimezone: this.$store.state.user.timezone,

                tableName: "jobsiteTable",
                exportingTable: false,

                columns: [
                    'JobsiteName',
                    'JobsiteNumber',
                    'DivisionName',
                    'Address',
                    'City',
                    'State',
                    'Zip',
                    'IsActive',
                    'pm_last_name',
                    'general_contractor',
                    'percent_risk',
                    'created_at',
                ],

                filterKey: 'jobsiteFilters',

                filterDefs: {
                    'jobsite.DivisionId': [],
                    'jobsite.IsActive': 1,
                    'jobsite.created_at': null,
                    'jobsite.project_manager_id': {},
                },
            }
        },

        watch: {
            appliedFilter(newVal, oldVal){
                //Call the helper
                this.checkForAppliedFilter();
            },
        },

        computed: {
            filters(){
                //Check State
                if(this.$store.state.tableFilters.filters[this.filterKey])
                {
                    //Send it
                    return this.$store.state.tableFilters.filters[this.filterKey];
                }

                //Return Definition
                return JSON.parse(JSON.stringify(this.filterDefs));
            },

            appliedFilter(){
                //Send it
                return this.$store.state.appliedFilters[this.filterKey] ? this.$store.state.appliedFilters[this.filterKey] : null;
            },

            options(){
                return {
                    headings: {
                        jobsiteName: 'Jobsite Name',
                        jobsiteNumber: 'Jobsite#',
                        DivisionName: 'Division',
                        percent_risk: 'Average RAC',
                        IsActive: 'Active',
                        pm_last_name: 'Project Manager',
                        general_contractor: 'GC',
                        created_at: 'Date Created',
                    },
                    saveState: this.allowFilterSaving,
                    columnsDropdown: customVTColDropdown,
                    visibleColumns: (this.allowFilterSaving ? this.$root.getVisibleColumnsFromState(this.tableName) : false),
                    sendInitialRequest: (this.filterId ? false : true),
                    orderBy: {
                        ascending: true,
                        column: 'jobsite.JobsiteName',
                    },
                    responseAdapter: (response) => {
                        //Emit the count
                        this.$emit('jobsiteListCount', response.data.count);

                        //Send it
                        return response.data;
                    },
                    requestAdapter: (data) => {
                        //Set the filters
                        data.filters = (this.dashboardFilters ? filterExtractor.extractFilters(this.dashboardFilters) : filterExtractor.extractFilters(this.filters));

                        //INclude the asset
                        data.assetType = this.assetType
                        data.assetId = this.assetId

                        //Send it
                        return data;
                    },
                    uniqueKey: 'jobsiteId',
                };
            },
        },

        methods: {
            riskLabel: function(value) {
                if (value <= Math.ceil(100/6))
                    return 'Low';
                else if (value <= Math.ceil(300/6))
                    return 'Medium';
                else if (value <= Math.ceil(500/6))
                    return 'High';
                else
                    return 'Extremely High';
            },

            riskColor: function(value) {
                if (value <= Math.ceil(100/6))
                    return 'success';
                else if (value <= Math.ceil(300/6))
                    return 'warning';
                else if (value <= Math.ceil(500/6))
                    return 'orange';
                else
                    return 'danger';
            },

            refreshTableData(filters) {
                //Set the data
                this.$refs.jobsiteTable.setPage(1);
                //this.$refs.jobsiteTable.getData();
            },

            filtersCleared(){
                //Reset
                this.refreshTableData();

                //Reset the Columns
                this.$refs.jobsiteTableFilters.resetColVis(this.$refs.jobsiteTable);
            },

            setUserFilterData(){
                //Call the Helper
                this.$refs.jobsiteSavedFilters.setFilterParams(this.$refs.jobsiteTable);
            },

            checkForAppliedFilter(){
                //Check if
                if(!this.allowFilterSaving || !this.appliedFilter)
                {
                    return;
                }

                //Call the helper
                this.$refs.jobsiteTableFilters.setColVis(this.$refs.jobsiteTable);
            },

            exportTable(){
                //Loading indicator
                this.exportingTable = true;

                //Build the Filters
                var filters = filterExtractor.extractFilters(this.filters);

                //Build the payload
                var payload = {
                    filters: filters,
                    query: (this.$refs[this.tableName].getRequestParams()).query,
                    orderBy: this.$refs[this.tableName].options.orderBy.column,
                    ascending: this.$refs[this.tableName].options.orderBy.ascending,
                    table: this.tableName,
                    columns: this.$refs[this.tableName].columns,
                    visible_columns: this.$root.getVisibleColumnsFromState(this.tableName),
                    export: true,
                    assetType: this.assetType,
                    assetId: this.assetId,
                    //load_custom_fields: true,
                    //custom_field_type: 'Employee',
                    //headings: this.$refs.employeesTable.options.headings,
                    // headings: {
                    //     project_manager_id: 'Project Manager',
                    // }
                };

                //Send it
                this.$http.get('/jobsite/list', payload)
                    .then(response => {
                        //Open the new window
                        window.open(response.data);

                        //Alert the User
                        this.$toastr.success('Export Complete');
                    })
                    .catch(err => {
                        //Alert the user
                        this.$toastr.error(err.response.data, 'Failed to Export Jobsites');
                    })
                    .then(response => {
                        //reset
                        this.exportingTable = false;
                    });
            },

        },

        mounted(){
            //Check for Staring Filters
            if(!this.dashboardFilters)
            {
                //Check for a saved filter
                this.checkForAppliedFilter();

                //Check for Filter ID
                if(this.filterId)
                {
                    this.$refs.jobsiteSavedFilters.setSavedFilter(this.filterId);
                }
            }

            //Check for Table Config
            if(this.tableConfig)
            {
                //Set it
                this.$refs.jobsiteTableFilters.setColVisFromSavedFilter(this.$refs.jobsiteTable, this.tableConfig);
            }
        }
    }
</script>
<style>
    .bg-orange {
        background-color: #ef871d;
        color: #fff;
    }

    .VueTables__table th:last-child{
        max-width: 130px;
        width: 130px;
    }
</style>